module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container clinic-multi"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', [_vm._v("สถานประกอบการในเครือ " + _vm._s(_vm.user.clinic_brand.name))]), _vm._v(" "), _c('p', [_vm._v("กรุณาเลือกสาขาที่ต้องการ")])]), _vm._v(" "), _vm._l((_vm.clinics), function(c) {
    return _c('div', {
      key: c.id,
      staticClass: "col-sm-12 col-md-4"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-body text-center"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/clinic/general',
          query: {
            ref_clinic_id: c.id
          }
        }
      }
    }, [_c('img', {
      staticClass: "rounded mx-auto d-block clinic-image",
      attrs: {
        "src": c.active_image
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(c.clinic_name))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(c.b_addr))])], 1)])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57d835b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/ClinicMulti.vue
// module id = 1014
// module chunks = 1